import { render, staticRenderFns } from "./cargaHorariaTeoricaTable.vue?vue&type=template&id=1068efb0"
import script from "./cargaHorariaTeoricaTable.vue?vue&type=script&lang=js"
export * from "./cargaHorariaTeoricaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports